import React from 'react';
import { getIsMobile } from '../../common/store/base-params/base-params-selectors';
import { useApi } from '../api-provider';
import { LockedCommentsIcon } from '../components/icons/locked-comments-icon';
import { useTranslate } from '../context/api-context/translations/use-translate';
import { st, classes } from './commenting-locked-empty-state.st.css';
const CommentingLockedEmptyState = () => {
    const isMobile = useApi(getIsMobile);
    const t = useTranslate();
    return (React.createElement("div", { className: st(classes.root, { isMobile }) },
        React.createElement(LockedCommentsIcon, { className: classes.icon }),
        React.createElement("span", { className: classes.text }, t('empty-state.commenting-locked-text'))));
};
export default CommentingLockedEmptyState;
//# sourceMappingURL=commenting-locked-empty-state.js.map